import React from 'react';
import PropTypes from 'prop-types';
import TreeRow from './TreeRow';
import PowertrainNode from './PowertrainNode';
import UnassignedNode from './UnassignedNode';
import IconLocation from 'svgIcons/MotionPortalIcons/IconLocation';
import { map } from 'lodash';
import { useNodeExpansion } from './HierarchyExpansionContext';

const LocationNode = ({
    location,
    depth,
    selectedAsset,
    onSelectAsset,
    leftPanelSize,
    allAssets,
    selectionNodeIds,
    selectedAssetSignalCounts
}) => {
    const { expanded, toggle } = useNodeExpansion(`location-${location?.locationId}`);
    const hasSelectionDot = !!selectionNodeIds?.has(`location-${location?.locationId}`);

    return (
        <>
            <TreeRow
                depth={depth}
                icon={<IconLocation />}
                label={location.name}
                hasChildren={!!(location?.assets?.length || location?.powertrains?.length || location?.subLocations?.length)}
                condition={location.condition}
                isExpanded={expanded}
                onToggle={toggle}
                hasSelectionDot={hasSelectionDot}
            />
            {expanded &&
                <>
                    {location?.assets?.length > 0 &&
                        <UnassignedNode
                            unAssignedNode={location.assets}
                            depth={depth + 1}
                            selectedAsset={selectedAsset}
                            onSelectAsset={onSelectAsset}
                            condition={location?.overallAssetCondition}
                            isForSingleAsset={true}
                            leftPanelSize={leftPanelSize}
                            allAssets={allAssets}
                            nodeId={`singleAssets-${location?.locationId}`}
                            selectionNodeIds={selectionNodeIds}
                            selectedAssetSignalCounts={selectedAssetSignalCounts}
                        />
                    }
                    {map(location?.powertrains, powertrain =>
                        <PowertrainNode
                            key={powertrain?.powertrainId}
                            powertrain={powertrain}
                            depth={depth + 1}
                            selectedAsset={selectedAsset}
                            onSelectAsset={onSelectAsset}
                            leftPanelSize={leftPanelSize}
                            allAssets={allAssets}
                            selectionNodeIds={selectionNodeIds}
                            selectedAssetSignalCounts={selectedAssetSignalCounts}
                        />
                    )}
                    {map(location?.subLocations, subLocation =>
                        <LocationNode
                            key={subLocation?.locationId}
                            location={subLocation}
                            depth={depth + 1}
                            selectedAsset={selectedAsset}
                            onSelectAsset={onSelectAsset}
                            leftPanelSize={leftPanelSize}
                            allAssets={allAssets}
                            selectionNodeIds={selectionNodeIds}
                            selectedAssetSignalCounts={selectedAssetSignalCounts}
                        />
                    )}
                </>
            }
        </>
    );
};

LocationNode.propTypes = {
    location: PropTypes.object.isRequired,
    depth: PropTypes.number.isRequired,
    selectedAsset: PropTypes.object,
    onSelectAsset: PropTypes.func,
    leftPanelSize: PropTypes.number,
    allAssets: PropTypes.array,
    selectionNodeIds: PropTypes.instanceOf(Set),
    selectedAssetSignalCounts: PropTypes.object
};

export default LocationNode;
